<template>
  <b-tabs>
    <b-tab>
      <template slot="title">
        <i class='icon-list'></i>
      </template>
      <b-list-group class="list-group-accent">
        <b-list-group-item class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
          Módulos
        </b-list-group-item>
        <b-list-group-item
          v-for="sistema in sistemas"
          v-if="sistema.idSistema != idSistema"
          href="#"
          class="list-group-item-accent-info"
        >
          <div><a href="#" @click="navegarUrl(sistema.url)"><strong>{{ sistema.nombre }}</strong></a>
          </div>
        </b-list-group-item>
        <hr class="transparent mx-3 my-0">
      </b-list-group>
    </b-tab>
  </b-tabs>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
export default {
  name: "DefaultAside",
  components: {
    cSwitch
  },
  methods: {
    // ir a url
    navegarUrl(url) {
      window.location = url;
    }
  },
  computed: {
    // obtener sistemas
    sistemas() {
      return this.$store.getters.getSistemas;
    },

    // obtener id sistema actual
    idSistema() {
      return process.env.VUE_APP_ID_SISTEMA;
    }
  }
};
</script>
